<!-- Un solo lienzo para los dos estados: al iniciar la conversación NO se cambia
     de interfaz, solo se reemplaza el bloque de bienvenida por los mensajes.
     El composer y el pie de privacidad son los mismos en ambos estados. -->
<div class="jh-stage" [class.jh-stage--chat]="hasConversation">
  <!-- Historial colapsable: el botón del diseño ahora abre un rail lateral con
       las conversaciones anteriores, en vez de ser decorativo. -->
  <button
    class="jh-history-toggle"
    type="button"
    [class.is-open]="historyOpen"
    [attr.aria-label]="'main.juana.history' | transloco"
    [title]="'main.juana.history' | transloco"
    (click)="toggleHistory()"
  >
    <i class="pi" [ngClass]="historyOpen ? 'pi-times' : 'pi-bars'"></i>
  </button>

  <div class="jh-layout">
    <aside class="jh-history" *ngIf="historyOpen">
      <button class="jh-new" type="button" [disabled]="juana.busy()" (click)="startNewConversation()">
        <i class="pi pi-plus"></i> {{ 'main.juana.newChat' | transloco }}
      </button>

      <!-- Único sitio de los accesos rápidos: antes eran tarjetas en la
           bienvenida y solo se veían con el chat vacío. -->
      <nav class="jh-menu">
        <h4 class="jh-history-section">{{ 'main.juana.quickActions' | transloco }}</h4>
        <button
          class="jh-menu-item"
          type="button"
          *ngFor="let action of quickActions"
          [disabled]="juana.busy()"
          (click)="runQuickAction(action)"
        >
          <i [ngClass]="action.icon"></i>
          <span>{{ action.labelKey | transloco }}</span>
        </button>
      </nav>

      <h4 class="jh-history-section jh-history-section--top">
        {{ 'main.juana.history' | transloco }}
      </h4>

      <p class="jh-history-empty" *ngIf="juana.conversations().length === 0">
        {{ 'main.juana.noHistory' | transloco }}
      </p>

      <div class="jh-history-group" *ngFor="let group of conversationGroups">
        <h4 class="jh-history-section">{{ group.label }}</h4>
        <ng-container *ngFor="let c of group.conversations">
          <!-- Renombrar: los títulos los redacta el agente, así que hace falta
               poder corregirlos cuando se equivoca. -->
          <input
            *ngIf="renamingId === c.id; else historyItem"
            class="jh-history-rename"
            type="text"
            [(ngModel)]="renameDraft"
            (keyup.enter)="confirmRename(c.id)"
            (keyup.escape)="cancelRename()"
            (blur)="confirmRename(c.id)"
            autofocus
          />
          <ng-template #historyItem>
            <div class="jh-history-row" [class.is-active]="c.id === juana.activeConversationId()">
              <button
                class="jh-history-item"
                type="button"
                [disabled]="juana.busy()"
                (click)="openConversation(c.id)"
                [title]="conversationLabel(c)"
              >
                {{ conversationLabel(c) }}
              </button>
              <button
                class="jh-history-rename-btn"
                type="button"
                [disabled]="juana.busy()"
                (click)="startRename($event, c)"
                [attr.aria-label]="'main.juana.rename' | transloco"
                [title]="'main.juana.rename' | transloco"
              >
                <i class="pi pi-pencil"></i>
              </button>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </aside>

    <div class="jh-content">
  <!-- Bienvenida (solo antes del primer mensaje) -->
  <ng-container *ngIf="!hasConversation">
    <div class="jh-hero">
      <span class="jh-glow" aria-hidden="true"></span>
      <svg class="jh-arcs" viewBox="0 0 600 320" preserveAspectRatio="none" aria-hidden="true">
        <path class="jh-arc jh-arc--outer" d="M 4 260 Q 300 16 596 260" />
        <path class="jh-arc jh-arc--inner" d="M 56 276 Q 300 96 544 276" />
      </svg>
      <img
        class="jh-portrait"
        src="assets/juana/juana-cutout.png"
        [alt]="'repuestos.agent.avatarAlt' | transloco"
      />
    </div>

    <h1 class="jh-greeting">{{ greeting }}</h1>
    <p class="jh-sub">{{ 'main.juana.subtitle' | transloco }}</p>
  </ng-container>

  <!-- Conversación: el mismo chat de siempre, sin su header ni su composer
       (los pone esta pantalla), heredando la paleta oscura del lienzo. -->
  <div class="jh-chat" *ngIf="hasConversation">
    <app-agent-panel variant="general" [chrome]="false"></app-agent-panel>
  </div>

  <div class="jh-composer" [class.jh-composer--busy]="juana.busy()">
    <textarea
      class="jh-input"
      rows="1"
      [placeholder]="'main.juana.inputPlaceholder' | transloco"
      [(ngModel)]="input"
      [disabled]="juana.busy()"
      (keydown.enter)="onEnter($event)"
    ></textarea>

    <div class="jh-composer-bar">
      <div class="jh-tools">
        <!-- Adjuntar y voz son parte del diseño pero todavía no tienen flujo
             detrás en esta superficie: se muestran deshabilitados en vez de
             fingir que funcionan. -->
        <button
          class="jh-tool"
          type="button"
          disabled
          [attr.aria-label]="'main.juana.attach' | transloco"
          [pTooltip]="'main.juana.comingSoon' | transloco"
        >
          <i class="pi pi-paperclip"></i>
        </button>
        <button
          class="jh-tool"
          type="button"
          disabled
          [attr.aria-label]="'main.juana.voice' | transloco"
          [pTooltip]="'main.juana.comingSoon' | transloco"
        >
          <i class="pi pi-microphone"></i>
        </button>
      </div>

      <button
        class="jh-send"
        type="button"
        [disabled]="juana.busy() || !input.trim()"
        (click)="send()"
        [attr.aria-label]="'repuestos.agent.send' | transloco"
      >
        <i class="pi pi-send"></i>
      </button>
    </div>
  </div>

      <p class="jh-privacy">
        <i class="pi pi-lock"></i>
        {{ 'main.juana.privacy' | transloco }}
      </p>
    </div>
  </div>
</div>
